import React, { Component } from 'react';

process.env.__CLIENT__ && require('./AfterSale.less');
export default class AfterSale extends Component {
  render() {
    return (
      <div className="aftersale">
          <div className="aftersale-left">
              <p className="text1">用友云营销服务重磅推出</p>
              <h1 className="text2">新商品中心全新升级</h1>
              <p className="text3">新架构  新服务  新体验</p>
              <a className="aftersalemore" href="https://mp.weixin.qq.com/s/m2rht5FPzexPqjQN0qtGlQ" target="_blank">点击了解</a>
          </div>
          <div className="aftersale-right"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/home/AfterSale.jsx